import {fork, put, select, take} from 'redux-saga/effects';
import {apmACEPartnerServiceTypes, apmACEPartnerTypes} from '@ace-de/eua-entity-types';
import * as samaActionTypes from '../samaActionTypes';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as serviceCaseHelpers from '../../service-cases/sagas/serviceCaseHelpers';

const searchSAMAServiceProvidersGoogleMaps = function* searchSAMAServiceProvidersGoogleMaps() {
    const {serviceManager} = yield select(state => state.application);
    const partnerManagementService = serviceManager.loadService('partnerManagementService');
    const googleMapsService = serviceManager.loadService('googleMapsService');

    while (true) {
        const {payload} = yield take(samaActionTypes.SEARCH_SAMA_SERVICE_PROVIDERS_GOOGLE_MAPS);
        const {serviceAssignment} = payload;
        const {serviceCaseId} = serviceAssignment;

        yield* serviceCaseHelpers.setPersistencePending(serviceCaseId);

        yield put({
            type: samaActionTypes.STORE_SAMA_SERVICE_PROVIDERS,
            payload: {medicalAdviceServiceProviders: []},
        });

        yield fork(
            fetchRequest,
            samaActionTypes.FETCH_SERVICE_PROVIDERS_REQUEST,
            partnerManagementService.getACEPartnersV2,
            {
                partnerType: apmACEPartnerTypes.SERVICE_PROVIDER,
                serviceType: apmACEPartnerServiceTypes.MEDICAL_ADVICE,
            },
        );

        const responseAction = yield take([
            samaActionTypes.FETCH_SERVICE_PROVIDERS_REQUEST_SUCCEEDED,
            samaActionTypes.FETCH_SERVICE_PROVIDERS_REQUEST_FAILED,
        ]);

        if (!responseAction.error) {
            const {response} = responseAction.payload;
            const {acePartnerDTOs} = response;

            if (!serviceAssignment.serviceLocation || !acePartnerDTOs?.length) continue;

            const referentialPoint = serviceAssignment.serviceLocation;

            yield fork(
                fetchRequest,
                samaActionTypes.FETCH_SERVICE_PROVIDER_GEOLOCATIONS_REQUEST,
                googleMapsService.sortDistances,
                {
                    origin: {
                        location:
                            {
                                latLng: {
                                    latitude: referentialPoint.latitude,
                                    longitude: referentialPoint.longitude,
                                },
                            },
                    },
                    destinations: acePartnerDTOs.map(acePartnerDTO => ({
                        apiUnrelatedFields: acePartnerDTO,
                        location: {
                            latLng: {
                                latitude: acePartnerDTO.location.latitude,
                                longitude: acePartnerDTO.location.longitude,
                            },
                        },
                    })),
                },
            );

            const fetchGeolocationsResponseAction = yield take([
                samaActionTypes.FETCH_SERVICE_PROVIDER_GEOLOCATIONS_REQUEST_SUCCEEDED,
                samaActionTypes.FETCH_SERVICE_PROVIDER_GEOLOCATIONS_REQUEST_FAILED,
            ]);

            if (fetchGeolocationsResponseAction.error) {
                yield* serviceCaseHelpers.setPersistenceReady(serviceCaseId);
                return;
            }

            const {response: fetchGeolocationResponse} = fetchGeolocationsResponseAction.payload;
            const {distances} = fetchGeolocationResponse;
            const medicalAdviceServiceProviders = distances.map(distance => ({
                ...distance.destination.apiUnrelatedFields,
                routeToReferentialPoint: {
                    totalKilometers: distance.distanceMeters / 1000,
                    totalTravelTime: Number(distance.duration.replace('s', '')) / 60,
                },
            }));

            yield put({
                type: samaActionTypes.STORE_SAMA_SERVICE_PROVIDERS,
                payload: {medicalAdviceServiceProviders},
            });

            yield* serviceCaseHelpers.setPersistenceReady(serviceCaseId);
        }
    }
};

export default searchSAMAServiceProvidersGoogleMaps;
